(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["card-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-card-slider]').forEach(function (sliderEl) {
      var track = sliderEl.querySelector('[data-slider-track]');
      var prevBtn = sliderEl.querySelector('[data-slider-prev]');
      var nextBtn = sliderEl.querySelector('[data-slider-next]');
      if (!track) return;

      function step() {
        var slide = track.querySelector('.card-slider__slide');
        return slide ? slide.getBoundingClientRect().width + 24 : track.clientWidth;
      }

      function updateArrows() {
        if (!prevBtn || !nextBtn) return;
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        prevBtn.disabled = track.scrollLeft <= 0;
        nextBtn.disabled = track.scrollLeft >= maxScroll;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tabs-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.collection-tabs').forEach(function (section) {
      var tabs = section.querySelectorAll('.collection-tabs__tab');
      var panels = section.querySelectorAll('.collection-tabs__panel');

      function setupSlider(sliderEl) {
        if (sliderEl.dataset.sliderReady) return;
        sliderEl.dataset.sliderReady = 'true';

        var track = sliderEl.querySelector('[data-slider-track]');
        var prevBtn = sliderEl.querySelector('[data-slider-prev]');
        var nextBtn = sliderEl.querySelector('[data-slider-next]');
        if (!track) return;

        function step() {
          var slide = track.querySelector('.collection-tabs__slider-slide');
          return slide ? slide.getBoundingClientRect().width + 24 : track.clientWidth;
        }

        function updateArrows() {
          if (!prevBtn || !nextBtn) return;
          var maxScroll = track.scrollWidth - track.clientWidth - 1;
          prevBtn.disabled = track.scrollLeft <= 0;
          nextBtn.disabled = track.scrollLeft >= maxScroll;
        }

        if (prevBtn) {
          prevBtn.addEventListener('click', function () {
            track.scrollBy({ left: -step(), behavior: 'smooth' });
          });
        }

        if (nextBtn) {
          nextBtn.addEventListener('click', function () {
            track.scrollBy({ left: step(), behavior: 'smooth' });
          });
        }

        track.addEventListener('scroll', updateArrows, { passive: true });
        updateArrows();
      }

      var activePanel = section.querySelector('.collection-tabs__panel.is-active');
      if (activePanel) {
        var activeSlider = activePanel.querySelector('[data-product-slider]');
        if (activeSlider) setupSlider(activeSlider);
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var targetId = tab.dataset.tabTarget;

          tabs.forEach(function (t) {
            var isActive = t === tab;
            t.classList.toggle('is-active', isActive);
            t.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          panels.forEach(function (panel) {
            var isTarget = panel.dataset.tabPanel === targetId;
            panel.classList.toggle('is-active', isTarget);
            if (isTarget) {
              var slider = panel.querySelector('[data-product-slider]');
              if (slider) setupSlider(slider);
            }
          });
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-cart-drawer"]) return;
  try {
    
  if (!customElements.get('goyu-cart-drawer')) {
    class GoyuCartDrawer extends HTMLElement {
      constructor() {
        super();
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onDrawerClick = this.onDrawerClick.bind(this);
        this.onCartRefresh = this.onCartRefresh.bind(this);
      }

      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('cart:refresh', this.onCartRefresh);
        this.addEventListener('click', this.onDrawerClick);
        this.dialog.addEventListener('close', () => {
          document.body.classList.remove('goyu-cart-open');
          this.activeElement?.focus();
        });
        this.syncGift(false);
        this.loadRecommendations();
        this.openFromUrl();
      }

      // /cart stuurt door naar ?cart=open (zie layout/cart.liquid): open de
      // drawer en haal de parameter weer uit de adresbalk.
      openFromUrl() {
        const url = new URL(window.location.href);
        if (url.searchParams.get('cart') !== 'open') return;
        url.searchParams.delete('cart');
        history.replaceState(history.state, '', url.pathname + url.search + url.hash);
        this.open();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('cart:refresh', this.onCartRefresh);
        this.removeEventListener('click', this.onDrawerClick);
      }

      onDocumentClick(event) {
        const trigger = event.target.closest('[data-cart-drawer-open]');
        if (!trigger) return;
        event.preventDefault();
        this.activeElement = trigger;
        this.open();
      }

      onDrawerClick(event) {
        if (event.target === this.dialog || event.target.closest('[data-cart-drawer-close]')) {
          this.close();
          return;
        }

        const quantityButton = event.target.closest('[data-cart-line-key][data-cart-quantity]');
        if (quantityButton) {
          this.updateLine(quantityButton.dataset.cartLineKey, Number(quantityButton.dataset.cartQuantity));
          return;
        }

        const recommendationButton = event.target.closest('[data-cart-recommendation-add]');
        if (recommendationButton) {
          this.addRecommendation(recommendationButton);
        }
      }

      onCartRefresh(event) {
        const sectionHtml = event.detail?.sections?.['custom-cart-drawer'];
        if (sectionHtml) {
          this.render(sectionHtml, event.detail.open !== false);
          return;
        }
        this.refresh(event.detail?.open !== false);
      }

      open() {
        if (!this.dialog.open) this.dialog.showModal();
        document.body.classList.add('goyu-cart-open');
      }

      close() {
        if (this.dialog.open) this.dialog.close();
      }

      async updateLine(lineKey, quantity) {
        await this.request('cart/change.js', { id: lineKey, quantity });
      }

      async addRecommendation(button) {
        const variantId = Number(button.dataset.variantId);
        if (!variantId) return;
        button.disabled = true;
        try {
          await this.request('cart/add.js', { items: [{ id: variantId, quantity: 1 }] });
        } finally {
          if (button.isConnected) button.disabled = false;
        }
      }

      async request(endpoint, payload, shouldOpen = true, syncGiftAfter = true) {
        this.setBusy(true);
        this.showError('');
        try {
          const response = await fetch(window.Shopify.routes.root + endpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              ...payload,
              sections: 'custom-cart-drawer',
              sections_url: window.location.pathname
            })
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message);
          this.render(data.sections['custom-cart-drawer'], shouldOpen, syncGiftAfter);
        } catch (error) {
          this.showError(error.message || window.cartStrings.error);
        } finally {
          this.setBusy(false);
        }
      }

      async refresh(shouldOpen = true) {
        this.setBusy(true);
        try {
          const response = await fetch(window.Shopify.routes.root + '?sections=custom-cart-drawer');
          const sections = await response.json();
          this.render(sections['custom-cart-drawer'], shouldOpen);
        } catch (error) {
          this.showError(error.message || window.cartStrings.error);
        } finally {
          this.setBusy(false);
        }
      }

      render(html, shouldOpen, syncGiftAfter = true) {
        if (!html) throw new Error(window.cartStrings.error);
        const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
        const nextDrawer = parsedDocument.querySelector('goyu-cart-drawer');
        const nextContent = nextDrawer?.querySelector('[data-cart-drawer-content]');
        const currentContent = this.querySelector('[data-cart-drawer-content]');
        if (!nextDrawer || !nextContent || !currentContent) throw new Error(window.cartStrings.error);

        currentContent.innerHTML = nextContent.innerHTML;
        this.dataset.itemCount = nextDrawer.dataset.itemCount;
        this.dataset.eligibleTotal = nextDrawer.dataset.eligibleTotal;
        this.dataset.giftThreshold = nextDrawer.dataset.giftThreshold;
        this.dataset.giftVariantId = nextDrawer.dataset.giftVariantId;
        this.dataset.giftLineKey = nextDrawer.dataset.giftLineKey;
        this.dataset.giftLineVariantId = nextDrawer.dataset.giftLineVariantId;
        this.dataset.hasFreeGift = nextDrawer.dataset.hasFreeGift;
        this.dataset.secondGiftThreshold = nextDrawer.dataset.secondGiftThreshold;
        this.dataset.secondGiftVariantId = nextDrawer.dataset.secondGiftVariantId;
        this.dataset.secondGiftLineKey = nextDrawer.dataset.secondGiftLineKey;
        this.dataset.hasSecondFreeGift = nextDrawer.dataset.hasSecondFreeGift;
        this.dataset.secondGiftEnabled = nextDrawer.dataset.secondGiftEnabled;
        this.dataset.autoAddGift = nextDrawer.dataset.autoAddGift;
        this.updateHeaderCount(nextDrawer.dataset.itemCount);
        if (shouldOpen) this.open();
        if (syncGiftAfter) this.syncGift(shouldOpen);
        this.loadRecommendations();
      }

      async loadRecommendations() {
        const container = this.querySelector('[data-cart-recommendations]');
        if (!container) return;

        const productIds = [...new Set(
          [...container.querySelectorAll('[data-cart-product-id]')]
            .map((element) => element.dataset.cartProductId)
            .filter(Boolean)
        )].slice(0, 3);
        const limit = Number(container.dataset.recommendationsLimit) || 4;
        const requestId = (this.recommendationRequestId || 0) + 1;
        this.recommendationRequestId = requestId;

        if (!productIds.length) {
          container.hidden = true;
          return;
        }

        try {
          const groups = await Promise.all(productIds.map(async (productId) => {
            const complementary = await this.fetchRecommendationCards(container, productId, limit, 'complementary');
            if (complementary.length) return complementary;
            return this.fetchRecommendationCards(container, productId, limit, 'related');
          }));

          if (requestId !== this.recommendationRequestId || !container.isConnected) return;

          const cartProductIds = new Set(productIds);
          const addedProductIds = new Set();
          const cards = [];

          for (const card of groups.flat()) {
            const productId = card.dataset.productId;
            if (!productId || cartProductIds.has(productId) || addedProductIds.has(productId)) continue;
            addedProductIds.add(productId);
            cards.push(card);
            if (cards.length >= limit) break;
          }

          const list = container.querySelector('[data-cart-recommendation-list]');
          list.replaceChildren(...cards);
          container.hidden = cards.length === 0;
        } catch (error) {
          container.hidden = true;
        }
      }

      async fetchRecommendationCards(container, productId, limit, intent) {
        const url = new URL(container.dataset.recommendationsUrl, window.location.origin);
        url.searchParams.set('section_id', 'cart-cross-sells');
        url.searchParams.set('product_id', productId);
        url.searchParams.set('limit', String(limit));
        url.searchParams.set('intent', intent);

        const response = await fetch(url);
        if (!response.ok) return [];
        const html = await response.text();
        const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
        return [...parsedDocument.querySelectorAll('[data-cart-recommendation-card]')];
      }

      async syncGift(shouldOpen = this.dialog.open) {
        if (this.syncingGift || this.dataset.autoAddGift !== 'true') return;

        const giftVariantId = Number(this.dataset.giftVariantId);
        const giftThreshold = Number(this.dataset.giftThreshold);
        const secondGiftVariantId = Number(this.dataset.secondGiftVariantId);
        const secondGiftThreshold = Number(this.dataset.secondGiftThreshold);
        const secondGiftEnabled = this.dataset.secondGiftEnabled === 'true';
        const eligibleTotal = Number(this.dataset.eligibleTotal);
        const hasFreeGift = this.dataset.hasFreeGift === 'true';
        const hasSecondFreeGift = this.dataset.hasSecondFreeGift === 'true';
        const giftLineKey = this.dataset.giftLineKey;
        const giftLineVariantId = Number(this.dataset.giftLineVariantId);
        const secondGiftLineKey = this.dataset.secondGiftLineKey;

        if (!giftVariantId || !giftThreshold || Number.isNaN(eligibleTotal)) return;

        this.syncingGift = true;
        try {
          if (hasFreeGift && giftLineKey && giftLineVariantId !== giftVariantId) {
            await this.request('cart/update.js', { updates: { [giftLineKey]: 0 } }, shouldOpen, false);
            return;
          }

          const itemsToAdd = [];

          if (eligibleTotal >= giftThreshold && !hasFreeGift) {
            itemsToAdd.push({
              id: giftVariantId,
              quantity: 1,
              properties: { _goyu_free_gift: 'true' }
            });
          }

          if (
            secondGiftEnabled &&
            secondGiftVariantId &&
            secondGiftThreshold &&
            eligibleTotal >= secondGiftThreshold &&
            !hasSecondFreeGift
          ) {
            itemsToAdd.push({
              id: secondGiftVariantId,
              quantity: 1,
              properties: { _goyu_free_gift_2: 'true' }
            });
          }

          if (itemsToAdd.length) {
            await this.request('cart/add.js', { items: itemsToAdd }, shouldOpen, false);
            return;
          }

          const updates = {};

          if (eligibleTotal < giftThreshold && hasFreeGift && giftLineKey) {
            updates[giftLineKey] = 0;
          }

          if (
            hasSecondFreeGift &&
            secondGiftLineKey &&
            (!secondGiftEnabled || !secondGiftVariantId || !secondGiftThreshold || eligibleTotal < secondGiftThreshold)
          ) {
            updates[secondGiftLineKey] = 0;
          }

          if (Object.keys(updates).length) {
            await this.request('cart/update.js', { updates }, shouldOpen, false);
          }
        } finally {
          this.syncingGift = false;
        }
      }

      updateHeaderCount(itemCount) {
        document.querySelectorAll('#cart-number').forEach((counter) => {
          counter.dataset.count = itemCount;
          const value = counter.querySelector('span');
          if (value) value.textContent = itemCount;
        });
      }

      setBusy(isBusy) {
        this.setAttribute('aria-busy', String(isBusy));
      }

      showError(message) {
        const errorElement = this.querySelector('[data-cart-drawer-error]');
        if (!errorElement) return;
        errorElement.textContent = message;
        errorElement.hidden = !message;
      }
    }

    customElements.define('goyu-cart-drawer', GoyuCartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-reviews-metaobjects"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-custom-reviews-slider]').forEach(function (sliderEl) {
      var track = sliderEl.querySelector('[data-slider-track]');
      var prevBtn = sliderEl.querySelector('[data-slider-prev]');
      var nextBtn = sliderEl.querySelector('[data-slider-next]');
      var dotsRoot = sliderEl.querySelector('[data-slider-dots]');
      if (!track) return;

      var slides = Array.prototype.slice.call(track.children);

      function step() {
        var slide = track.querySelector('.custom-reviews__slide');
        return slide ? slide.getBoundingClientRect().width + 24 : track.clientWidth;
      }

      function updateArrows() {
        if (!prevBtn || !nextBtn) return;
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        prevBtn.disabled = track.scrollLeft <= 0;
        nextBtn.disabled = track.scrollLeft >= maxScroll;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }
      track.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();

      if (dotsRoot && slides.length > 1) {
        slides.forEach(function (slide, i) {
          var dot = document.createElement('span');
          dot.className = 'custom-reviews__dot';
          if (i === 0) dot.classList.add('is-active');
          dotsRoot.appendChild(dot);
        });
      }
      var dots = dotsRoot ? Array.prototype.slice.call(dotsRoot.children) : [];

      if (slides.length && dots.length && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.intersectionRatio < 0.6) return;
            var i = Number(entry.target.dataset.index);
            dots.forEach(function (d, n) {
              d.classList.toggle('is-active', n === i);
            });
          });
        }, { root: track, threshold: [0.6] });
        slides.forEach(function (slide) { io.observe(slide); });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              this.initSlider();
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }

    // Zelfde slider-instellingen als .product-slider__items in essentials.js
    initSlider() {
      const items = this.querySelector('.product-slider__items');
      if (!items) return;
      if (!window.jQuery || !window.jQuery.fn.slick) {
        // jQuery/slick (deferred in header) nog niet geladen: later opnieuw proberen
        if ((this.sliderRetries = (this.sliderRetries || 0) + 1) <= 20) setTimeout(() => this.initSlider(), 250);
        return;
      }
      window.jQuery(items).slick({
        dots: false,
        infinite: true,
        speed: 600,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '<div class="product-slider__arrow product-slider__arrow--prev"><svg width="16" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.827.242A.719.719 0 0 1 11.63.05a.83.83 0 0 1 .432.192 49.882 49.882 0 0 1 3.146 2.876c.434.432.219 1.001-.18 1.252-2.109 2.508-4.515 4.991-6.62 7.501 2.387 2.4 4.689 5.117 6.98 7.605.257.28.267.608.144.877-.02.256-.175.49-.398.663a50.513 50.513 0 0 0-3.042 2.553c-.247.405-.824.629-1.263.196C7.32 20.317 4.25 16.431.402 13.34a.76.76 0 0 1-.22-.274c-.221-.29-.277-.708.04-1.05C3.813 8.14 7.148 4.036 10.828.242Z" fill="#EBEBEB"/></svg></div>',
        nextArrow: '<div class="product-slider__arrow product-slider__arrow--next"><svg width="16" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.173.242A.719.719 0 0 0 4.37.05a.83.83 0 0 0-.432.192A49.878 49.878 0 0 0 .793 3.118C.359 3.55.574 4.12.973 4.37 3.083 6.878 5.49 9.36 7.594 11.87c-2.387 2.4-4.689 5.117-6.98 7.605a.773.773 0 0 0-.144.877c.02.256.175.49.398.663a50.515 50.515 0 0 1 3.042 2.553c.247.405.824.629 1.263.196 3.507-3.448 6.578-7.334 10.426-10.425a.76.76 0 0 0 .22-.274c.221-.29.277-.708-.04-1.05C12.188 8.14 8.852 4.036 5.172.242Z" fill="#EBEBEB"/></svg></div>'
      });
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-row"]) return;
  try {
    

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-card-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-reviews-card-slider]').forEach(function (sliderEl) {
      var track = sliderEl.querySelector('[data-slider-track]');
      var prevBtn = sliderEl.querySelector('[data-slider-prev]');
      var nextBtn = sliderEl.querySelector('[data-slider-next]');
      if (!track) return;

      function step() {
        var slide = track.querySelector('.reviews-card-slider__slide');
        return slide ? slide.getBoundingClientRect().width + 24 : track.clientWidth;
      }

      function updateArrows() {
        if (!prevBtn || !nextBtn) return;
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        prevBtn.disabled = track.scrollLeft <= 0;
        nextBtn.disabled = track.scrollLeft >= maxScroll;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
